import axios from "axios"

export const getDataByFetch = (url, config = { Accept: "application/json" }) => axios.get(url, config)

export const postDataByFetch = (url, data, config = { Accept: "application/json" }) => axios.post(url, data, config)

export const putDataByFetch = (url, config = { Accept: "application/json" }) => axios.put(url, config)
